// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"70d5a91d","884":"6211062f"}[chunkId] + ".chunk.js";
};